import { cloneDeep, times } from 'lodash';
import createTaskType from '../../createTaskType';
import SpellingEditor from './Editor';

export default createTaskType({
    id: 'spelling',
	label: 'Spelling',
    skill: 'reading_writing',
    v2: true,
    hasRubric: true,

    editor: SpellingEditor,
    createItemsTemplate: () => times(6, index => ({
        is_example: index === 0,
        ...(index === 0 && {
            rubric_id: '',
        }),

        image_id: '',
        answers: [{
            is_correct_answer: true,
            stimulus: '',
            /** @type {string[]} */
            key: [],
            // Only included in 'phase 1' items
            ...(index < 3 && {
                fill_text: '',
            }),
        }],
    })),

    backgroundImages: {
        count: 2,
		description: 'Two background images are present in the Spelling task, one for each part. The first image wil be seen before and during example and item 1 and 2, while the second is seen before and during items 3-5.',
        configs: [
            { label: 'Background image for Ex, items 1 & 2' },
            { label: 'Background image for items 3-5' },
        ],
    },

    convertToUploadFormat(task, { isNew }) {
        task = cloneDeep(task);

        delete task.final_audio_id;

        return task;
    },

    getKeys: (item) => {
        return item.answers.filter(x => x.is_correct_answer).map(x => x.key.join(', '));
    }
});